



import {Component, Vue} from 'vue-property-decorator';
import AddNewBabyForm from "@/components/Molecules/AddBabyForm/AddNewBaby.vue";
import {AddBabyFormDto, BabyFormType} from "@/share";
import {ServiceFactory} from "@/services";
const BabyService = ServiceFactory.get('baby');
@Component({
  components: {
    AddNewBabyForm,
  }
})
export default class AddNewBaby extends Vue {
  private isLoading = false
  private error = ''
  private errorMessages = []

  private async addNewBaby(formData: BabyFormType) {
    const {babyName, babyBirthday} = formData;
    const data: AddBabyFormDto = new AddBabyFormDto({
      name: babyName || '',
      birthday: babyBirthday + " 00:00:00" || '',
    })
    this.error = ''
    this.isLoading = true
    let response = await BabyService.addNewBaby(data).catch(()=>({}));
    this.isLoading = false
    if (response.hasError) {
      this.error = response.message
      return this.errorMessages = response.errors
    }

    return this.$router.push({ name: 'routes.tutorial.start', params: {id:response.id} })
  }
}
